import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/hotels-standalone`;

export default function RetailerAlertTapHandler() {
  const { tagId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    handleTap();
  }, [tagId]);

  const handleTap = async () => {
    try {
      const response = await fetch(`${API_URL}/retailer-alert/${tagId}?format=json`);
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || 'Tag not found');
      }
      const data = await response.json();
      if (data.redirect_url) {
        navigate(data.redirect_url);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-fuchsia-600 to-fuchsia-800 flex items-center justify-center p-4">
        <Card className="w-full max-w-md bg-white shadow-2xl">
          <CardContent className="pt-6 text-center">
            <AlertTriangle className="w-12 h-12 text-fuchsia-500 mx-auto mb-3" />
            <p className="text-red-600 text-lg font-medium mb-2">Error</p>
            <p className="text-gray-600">{error}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-fuchsia-600 to-fuchsia-800 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white shadow-2xl">
        <CardContent className="pt-6 flex items-center justify-center">
          <Loader2 className="w-8 h-8 animate-spin text-fuchsia-500" />
          <span className="ml-3 text-gray-600">Loading...</span>
        </CardContent>
      </Card>
    </div>
  );
}
